import React from "react";
import { connect } from "react-redux";
import * as XLSX from "xlsx";
import { IconButton } from "@material-ui/core";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import Swal from "sweetalert2";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Papa from 'papaparse';

const ExportExcelV2 = (props) => {
  const wb = XLSX.utils.book_new();
  let survey_data = initSurveyData(props);
  let choices_data = initChoicesData(props);
  let settings_data = [
    {
      form_title: props.form_title,
      form_id: {
        f: 'CONCATENATE(I2,"_G",H2)',
      },
      version: {
        f: 'TEXT(YEAR(NOW())-2000, "00") & TEXT(MONTH(NOW()), "00") & TEXT(DAY(NOW()), "00") & TEXT(HOUR(NOW()), "00") & TEXT(MINUTE(NOW()), "00")',
      },
      instance_name: props.instance_name,
      public_key: props.public_key,
      submission_url: props.submission_url,
      default_language: props.default_language,
      generation: props.generation,
      family: props.family,
    },
  ];
  const ws_survey = XLSX.utils.json_to_sheet(survey_data);
  const ws_choices = XLSX.utils.json_to_sheet(choices_data);
  const ws_settings = XLSX.utils.json_to_sheet(settings_data);
  XLSX.utils.book_append_sheet(wb, ws_survey, "survey");
  XLSX.utils.book_append_sheet(wb, ws_choices, "choices");
  XLSX.utils.book_append_sheet(wb, ws_settings, "settings");
  return (
    <IconButton
      aria-label="save"
      onClick={() => {
        if (document.getElementsByClassName("duplicate-name").length === 0) {
          if (props.family.length > 0) {
            createFileZip(wb, props);
          } else {
            Swal.fire(
              "Warning!",
              "Form Family cannot be left blank",
              "warning"
            );
          }
        } else {
          Swal.fire(
            "Warning!",
            "Question name duplicate or invalid, please check again!",
            "warning"
          );
        }
      }}
    >
      <SaveAltIcon />
    </IconButton>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.form_settings,
    choices_list: state.choices_list,
    questions: { ...state.questions },
    questionsList: { ...state.questionsList },
    pages: { ...state.pages },
    languages: [...state.languages],
    form_configs: {...state.form_configs},
    theme_config: {...state.theme_config}
  };
};

export default connect(mapStateToProps)(ExportExcelV2);
function prepareSurveySheet(languages) {
  let columns = [
    "type",
    "name",
    "label",
    "hint",
    "appearance",
    "default",
    "required",
    "required_message",
    "constraint",
    "constraint_message",
    "relevant",
    "calculation",
    "readonly",
    "disabled",
    "repeat_count",
  ];
  let excel_columns = [];
  columns.forEach((column) => {
    if (
      ["label", "hint", "required_message", "constraint_message"].indexOf(
        column
      ) >= 0
    ) {
      if (languages.length > 0) {
        languages.forEach((language) => {
          excel_columns = [...excel_columns, `${column}::${language}`];
        });
      } else {
        excel_columns = [...excel_columns, column];
      }
    } else {
      excel_columns = [...excel_columns, column];
    }
  });
  return excel_columns;
}
function initSurveyData(state) {
  let prepareSurvey = prepareSurveySheet(state.languages);
  let initRow = {
    type: "start",
    name: "starttime",
  };
  prepareSurvey.forEach((key) => {
    if (!initRow[key]) {
      initRow = { ...initRow, [key]: "" };
    }
  });
  let survey_data = [
    initRow,
    { type: "end", name: "endtime" },
    {
      type: "calculate",
      name: "starttime_str",
      calculation: "string(format-date-time(${starttime},'%d/%m/%Y %H:%M:%S'))",
    },
    {
      type: "calculate",
      name: "uuid_ssname",
      calculation: "concat('" + state.family + "_',${starttime_str})",
    },
    state.questionsList["language"],
    state.questionsList["displaytitle"],
  ];
  Object.entries(state.pages).forEach((page, index) => {
    survey_data = [
      ...survey_data,
      {
        type: "begin group",
        name: state.questionsList[page[0]].name,
        appearance: state.questionsList[page[0]].appearance
          ? state.questionsList[page[0]].appearance
          : "field-list grid(weight = 6)",
      },
    ];
    page[1].forEach((question) => {
      if (
        state.questionsList[question].type === "group_template" ||
        state.questionsList[question].type === "group" ||
        state.questionsList[question].type === "repeat"
      ) {
        if (state.questionsList[question].type === "group_template") {
          state.questionsList[question].type = "group";
        }
        survey_data = [
          ...survey_data,
          {
            type: `begin ${state.questionsList[question].type}`,
            name: state.questionsList[question].name,
            appearance: state.questionsList[question].appearance,
          },
        ];

        state.questionsList[question].children.forEach((childrenQuestion) => {
          let questionRow = prepareQuestionRow(state, childrenQuestion);
          survey_data = [...survey_data, questionRow];
        });

        survey_data = [
          ...survey_data,
          {
            type: `end ${state.questionsList[question].type}`,
          },
        ];
      } else {
        let questionRow = prepareQuestionRow(state, question);
        survey_data = [...survey_data, questionRow];
      }
    });
    // let questionRow = index;
    survey_data = [
      ...survey_data,
      {
        type: "end group",
      },
    ];
  });
  survey_data.map((row) => {
    let newRow = row;
    Object.keys(row).forEach((key) => {
      if (prepareSurvey.indexOf(key) === -1) {
        delete newRow[key];
      }
    });
    return newRow;
  });
  // console.table('survey_data',survey_data)
  return survey_data;
}

function initChoicesData(props) {
  let choices_list_data = [];

  if (props.choices_list.length > 1) {
    props.choices_list.forEach((row, index) => {
      if (index > 0 && index < props.choices_list.length) {
        let rowData = {};
        row.forEach((cell, cellIndex) => {
          rowData[props.choices_list[0][cellIndex]] = cell;
        });

        choices_list_data = [...choices_list_data, rowData];
      }
    });
  } else {
    props.choices_list.forEach((row, index) => {
      let rowData = {};
      row.forEach((cell, cellIndex) => {
        rowData[props.choices_list[0][cellIndex]] = "";
      });

      choices_list_data = [...choices_list_data, rowData];
    });
  }
  return choices_list_data;
}

function prepareQuestionRow(state, question) {
  let questionRow = {};
  let questionData = state.questionsList[question];
  if(!questionData){
    return questionRow
  }
  if (questionData.relevant !== false) {
    questionData.relevant = state.questionsList[question].relevant_expr
      ? state.questionsList[question].relevant_expr
      : state.questionsList[question].relevant;
  }
  if (questionData.constraint !== false) {
    questionData.constraint = state.questionsList[question].constraint_expr
      ? state.questionsList[question].constraint_expr
      : state.questionsList[question].constraint;
  }
  if (questionData.required !== false) {
    questionData.required = state.questionsList[question].required_expr
      ? state.questionsList[question].required_expr
      : state.questionsList[question].required;
  }

  Object.keys(questionData).forEach((attr) => {
    questionRow[attr] =
      typeof questionData[attr] === "boolean"
        ? questionData[attr] === false
          ? ""
          : questionData[attr].toString()
        : questionData[attr];
  });
  return questionRow;
}

function createFileZip(wb, props) {
  const zip = new JSZip();
  // xlsx
  const wbArrayBuffer = XLSX.write(wb, { type: "array" });
  const data = new Blob([wbArrayBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  //tfConfig
  const themeConfig = prepareDataThemeConfig(props.theme_config)
  const themeConfigFile = Papa.unparse(themeConfig);
  //formSetting
  const formSetting = prepareDataFormSetting(props.form_configs)
  const formSettingFile = Papa.unparse(formSetting);
  //zip
  zip.file("tfConfig.csv", themeConfigFile);
  zip.file("formSetting.csv", formSettingFile);
  zip.file(props.form_id + ".xlsx", data);
  zip.generateAsync({ type: "blob" }).then((content) => {
    saveAs(content, props.form_id+".zip");
  });
}

function prepareDataThemeConfig(themeConfig){
 let data =  Object.entries(themeConfig).map((arr)=>{
    return {
        type : "text",
        name: arr[0],
        value: arr[1],
        disable : "no",
        note:"",
        description:""
        
    }
})
return data
}
function prepareDataFormSetting(formSetting){
  let data =  Object.entries(formSetting).map((arr)=>{
     return {
         type : "text",
         name: arr[0],
         value: arr[1],
         disable : "no",
         note:"",
         description:""
         
     }
 })
 return data
 }